const getDistance = (latitudeFrom, longitudeFrom, latitudeTo, longitudeTo, earthRadius = 3959) => {
    const toRadians = (degrees) => degrees * (Math.PI / 180);
    const latFrom = toRadians(latitudeFrom);
    const lonFrom = toRadians(longitudeFrom);
    const latTo = toRadians(latitudeTo);
    const lonTo = toRadians(longitudeTo);
  
    const latDelta = latTo - latFrom;
    const lonDelta = lonTo - lonFrom;
  
    const angle = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(latDelta / 2), 2) +
      Math.cos(latFrom) * Math.cos(latTo) * Math.pow(Math.sin(lonDelta / 2), 2)));
    return angle * earthRadius;
  };

export default getDistance;
  